import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  { path: '', redirectTo: 'spay', pathMatch: 'full' },
  { path: 'utilisateur/admin/ledger', redirectTo: 'utilisateur/admin/ledger/accounts', pathMatch: 'full' },
  { path: 'utilisateur/admin/billing', redirectTo: 'utilisateur/admin/billing/invoices', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false, onSameUrlNavigation: 'reload' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
